module.exports = __webpack_public_path__ + "img/accepted.143d1ce1.png";